import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useMemo } from 'react';
import { PAYMENTS_MANUAL_EMAILS } from '../../../constants/scopes';
import { useHasScope } from '../../../hooks/useHasScope';
import { jsx as _jsx } from "react/jsx-runtime";
function SendAuthorizationCopyActionButton({
  isAccountEnabled,
  paymentStatus,
  onClick
}) {
  const canSendEmails = useHasScope(PAYMENTS_MANUAL_EMAILS);
  const validationMessage = useMemo(() => {
    if (!isAccountEnabled) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardPaymentHighlight.paymentHighlight.sidebarActions.noAccess.accountDisconnected"
      });
    }
    if (!canSendEmails) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardPaymentHighlight.paymentHighlight.sidebarActions.noAccess.default"
      });
    }
    if (paymentStatus === 'failed') {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendBankAuthorization.failedPaymentTooltip"
      });
    }
    return null;
  }, [canSendEmails, paymentStatus, isAccountEnabled]);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: validationMessage,
    children: /*#__PURE__*/_jsx(Button, {
      onClick: onClick,
      disabled: Boolean(validationMessage),
      "data-test-id": "payment-sidebar-actions--send-authorization-copy",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendBankAuthorization.buttonText"
      })
    })
  });
}
export default SendAuthorizationCopyActionButton;